import { Link } from "react-router-dom";

// The statement that continuing constitutes acceptance of our terms and
// acknowledgement of the privacy notice.
//
// Android has shown this on its sign-in screen for a long time
// (`fui_tos_and_pp`, composed in `ChooseLoginMethodViewModel`); the web app had
// nothing equivalent, so a web sign-in was not an acceptance of anything. It sits
// above the account-switch link on every auth screen, so it is visible whichever
// route the user takes — Google or email.
//
// Wording deliberately splits the two: the terms are *accepted*, while the privacy
// notice is *acknowledged as read*. A GDPR art. 13 notice is information we provide,
// not something the client consents to.
export function LegalNotice() {
  return (
    <p className="auth-legal">
      Dacă alegi să continui, accepți{" "}
      <Link to="/termeni">Termenii și condițiile</Link> și confirmi că ai citit{" "}
      <Link to="/confidentialitate">Informarea privind prelucrarea datelor</Link>.
    </p>
  );
}
